import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "checkForFullWidth" })
export class CheckForFullWidth implements PipeTransform {
  constructor() {
  }
  transform(value: any) {
    console.log(value);
    let allowNotice = true;
    if (typeof value != "undefined" && value != null) {
      value.forEach(bodyElement => {
        bodyElement.left.forEach(element => {
          if (element.FieldName == "Notices" && typeof element.NoticeMode != "undefined" && element.NoticeMode.includes('Visible')) {
            allowNotice = false;
          }
        });
      });
    }

    return allowNotice;
  }
}




// WEBPACK FOOTER //
// ./src/pipes/checkForFullWidth.ts